import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AutomatedTransferNotificationMessage } from '../../../../../../pages/transfers/automated-transfers/contract/automated-transfers-notification.contract';
import { AutomatedTransferNotification } from '../../../../../../pages/transfers/contract/automated-transfer-notification.contract';
import { AutomatedTransferNotificationType } from '../../../../../../pages/transfers/enum/automated-transfer-notification-type.enum';
import { DatesService } from '../../../../../../shared/services/dates.service';
import { LanguageService } from '../../../../../services/language.service';

@Injectable({ providedIn: 'root' })
export class ATNotificationToMessageService {
  private languageService = inject(LanguageService);
  private router = inject(Router);
  private datesService = inject(DatesService);

  convert(notifications: AutomatedTransferNotification[]): (AutomatedTransferNotificationMessage | null)[] {
    return notifications.map((notification: AutomatedTransferNotification) => {
      const message = this.convertToMessageWithoutRedirectCallback(notification);

      return {
        ...message,
        redirectCb: this.getRedirectCallbackForType(notification.notificationType, notification.redirectUrl),
      };
    });
  }

  private getRedirectCallbackForType(notificationType: AutomatedTransferNotificationType, redirectUrl?: string) {
    switch (notificationType) {
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_EQUIPMENT_BLOCKED:
        return () => {
          if (redirectUrl) {
            this.router.navigate([redirectUrl]);
          }
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_GEOFENCE_ENTERED:
        return () => {
          // TODO
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_GEOFENCE_LEFT:
        return () => {
          // TODO
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_ITEM_PAUSED:
        return () => {
          // TODO
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_COMPLETED:
        return () => {
          // TODO
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_CANCELLED:
        return () => {
          // TODO
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_DELIVERY_TIME_EXCEEDED:
        return () => {
          // TODO
        };

      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_GEOFENCE_CHANGES:
        return () => {
          // TODO
        };

      default:
        return () => {};
    }
  }

  private convertToMessageWithoutRedirectCallback({
    notificationId,
    notificationType,
    notificationBodyTranslationKey,
    notificationTitleTranslationKey,
    notificationTranslationParams,
  }: AutomatedTransferNotification): AutomatedTransferNotificationMessage {
    const timestamp = notificationTranslationParams['timestamp'];

    return {
      notificationId,
      notificationType,
      title: this.translate(notificationTitleTranslationKey),
      body: this.translate(notificationBodyTranslationKey, {
        ...notificationTranslationParams,
        timestamp: timestamp ? this.formatTimestamp(timestamp) : null,
      }),
      redirectCb: () => {},
    };
  }

  private formatTimestamp(timestamp: string) {
    return this.datesService.dateFormatLocale(timestamp, {
      dateFormat: 'LL',
      showTime: true,
      hideEndOfDayTime: false,
    });
  }

  private translate(key: string, interpolateParams?: object): string {
    return this.languageService.getInstant(key, interpolateParams);
  }
}
